// extracted by mini-css-extract-plugin
export default {"expansionButton":"_2rGvl","expansionIcon":"_1J8N1","rotated":"_3IYad"};